import { Base } from '@studiometa/js-toolkit';
import Slider from './Slider.js';

/**
 * Homepage class.
 */
export default class Project extends Base {
  /**
   * Class config
   * @type {object}
   */
  static config = {
    name: 'Project',
    refs: ['panel', 'btn'],
    components: {
      Slider,
    },
  };

  /**
   * Click on btn to open panel
   * @param  {object} e element
   * @returns {void}
   */
  onBtnClick(e) {
    e.preventDefault();
    this.openPanel();
  }

  /**
   * Detect when clicked outside the panel
   * @param  {object} e element
   * @returns {void}
   */
  onPanelClick(e) {
    if (e.target === this.$refs.panel) {
      this.closePanel();
    }
  }

  /**
   * Close panel and go back to top of section
   * @returns {void}
   */
  closePanel() {
    window.location.hash = `#${this.$el.dataset.hash}-section`;
  }

  /**
   * Open panel
   * @returns {void}
   */
  openPanel() {
    window.location.hash = `#${this.$el.dataset.hash}`;
  }
}
